export default __webpack_public_path__ + "static/media/img-03.ed8f48fe.png";